<template>
  <div class="row column">
    <br />
    <h5 class="text-center">
      <unicon name="cloud-share" :fill="secCol" style="margin-right: 8px;">
      </unicon>
      <span class="text-barlow-condensed">Recursos</span>
    </h5>

    <ul
      class="vertical menu kal-aside-menu__list"
      data-responsive-menu="drilldown medium-accordion"
    >
      <li v-for="(item, index) in menu.resources.children" :key="index">
        <a>
          <unicon :name="item.icon" :fill="secCol"></unicon>
          <router-link
            :to="item.link"
            v-slot="{ href, route, navigate, isExactActive }"
          >
            <span
              :href="href"
              @click="navigate"
              :class="[
                isExactActive || 'subtitle',
                isExactActive && 'text-logo',
              ]"
              >{{ item.text }}</span
            >
          </router-link>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ResourcesMenu",
  data() {
    let { secCol } = this.$store.getters;

    return {
      secCol,
    };
  },
  computed: {
    ...mapState(["menu"]),
  },
};
</script>
